import { useMutation } from '@tanstack/react-query';

import { PayStationFormSchemaValues } from 'src/features/payment/utils/formSchema';
import { PayStation } from 'src/features/payment/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/paystations/pay-station/`;

type DTO = {
    data: PayStationFormSchemaValues;
    parkingId: string;
};

type MutationFnType = typeof mutationFn;
const mutationFn = ({ data, parkingId }: DTO): Promise<PayStation> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreatePayStation };
